// @ts-nocheck



import CommonApi from './../commonApi';
import { downloadRequestWithToken, fetchRequest } from './index';



const oilsAndFluidsConsumptionPlan = new CommonApi(
  'oilsAndFluidsConsumptionPlan',
  'План расхода масел и техжидкостей'
);

export const changeStatus = async (data) =>


{
  const updated = await fetchRequest.put(
    `/oilsAndFluidsConsumptionPlan/changeStatus`,
    data
  );
  if (updated) return updated;
  throw new Error(`Не удалось сменить статус`);
};

export const print = async (params) => {
  const printed = await downloadRequestWithToken(
    '/oilsAndFluidsConsumptionPlan/residueValuesReport/print',
    {
      ...params
    }
  );
  if (printed) return printed;
  throw new Error('Не удалось распечатать отчет');
};

export default {
  ...oilsAndFluidsConsumptionPlan,
  changeStatus,
  print
};
